// hooks/useSyncCartToProducts.js
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCartFieldsInProducts } from "../store/reducer/productSlice";

const SyncCartToProducts = () => {
    const dispatch = useDispatch();
    const cartItems = useSelector((state) => state.cart?.cartData?.item_info);
    const ProductList = useSelector((state) => state.products?.ProductList);
    useEffect(() => {
        if (cartItems && typeof cartItems === "object") {
            const transformedCart = {};

            for (const [sku, item] of Object.entries(cartItems)) {
                transformedCart[sku] = {
                    qty: item.product_quantity || 0,
                    preference: item.product_preference || null,
                    instruction: item.product_instruction || null,
                };
            }
            //console.log(transformedCart)
            dispatch(updateCartFieldsInProducts(transformedCart));
        } else {
            dispatch(updateCartFieldsInProducts());
        }
    }, [cartItems, dispatch, ProductList]);

    return null;
};

export default SyncCartToProducts;